<!----------------------------------------------------------------------------------------->
<!----------------------            "Main Display Heading"         ------------------------>
<!-----------   The blueish bar across the top of the Main Display ------------------------>
<!-----------   Contains topic name, context sensitive Help link, and Glossary link  ------>
<!----------------------------------------------------------------------------------------->


<!-- The Main Menu Heading should not be shown for some Menu options, add them to this *ngIf.  -->
<div class="main-display-heading">

    <span class="pl-1">{{toolHeadingName}}</span>

    <span
        class="float-right clicker mr-1"
        (click)="openHelpWindow('https://wiki.nci.nih.gov/x/9ICUBg')"
    >Glossary
    </span>

    <span *ngIf="helpUrl!=''"
        class="float-right clicker mr-2"
    (click)="openHelpWindow(helpUrl)"
    >Help
    </span>

    <span *ngIf="exportXML"
        class="float-right clicker mr-2"
        matTooltip="Exports over 200 records may time out."
        matTooltipClass="canano-tooltip"
    (click)="exportAsXML()"
    >Export (XML)
    </span>


    <span *ngIf="exportJSON"
        class="float-right clicker mr-2"
          matTooltip="Exports over 200 records may time out."
          matTooltipClass="canano-tooltip"
    (click)="exportAsJSON()"
    >Export (JSON)
    </span>

    <span *ngIf="export"
        class="float-right clicker mr-2"
          matTooltip="Exports over 200 records may time out."
          matTooltipClass="canano-tooltip"
    (click)="exportAsXLS()"
    >Export
    </span>

    <span *ngIf="otherUrl"
        class="float-right clicker mr-2" (click)="navigateToOtherUrl()">
        {{otherUrl['title']}}
    </span>


    <span class="float-right clicker mr-2" *ngIf="print" (click)="printPage()">
            Print
    </span>

    <span class="float-right clicker mr-2" *ngIf="backUrl">
        <button (click)="navigateBack()" class="btn-canano btn-canano-success btn-canano-xs mr-1">
            Back
        </button>
    </span>

</div>
